/**
 * Resizes the content container to adjust it to chat window size
*/
export function resizeContentHeight(chatWindowElement, containerElement) {
    if ($('.chatbotWindow.cbot-chatWindow--visible')) {
        let contentHeight = getContentHeight(chatWindowElement); 
        let chatWindow = $('.cbot-chatWindow').height();
        let heightVar = chatWindow - contentHeight + 'px';
        containerElement.css('max-height', heightVar);
        containerElement.css('height', heightVar);
    }
}

export function getContentHeight(chatWindowElement) {
    let contentHeight = 0;
    chatWindowElement.find('.cbot-js-content-space').each((index, element) => {
        let jqe = $(element);
        if (jqe.is(':visible')) {
            contentHeight += jqe.outerHeight();
            contentHeight += parseInt(jqe.css("margin-top")) > 0 ? parseInt(jqe.css("margin-top")) : 0;
            contentHeight += parseInt(jqe.css("margin-bottom")) > 0 ? parseInt(jqe.css("margin-bottom")) : 0;
        }
    });
    return contentHeight;
}